import {gql, useMutation} from '@apollo/client';

import {CreateAuthenticationTokenMutation} from '#apollo/schema';
import {CreateAuthenticationTokenMutationVariables} from '#apollo/schema';

const createAccessTokenMutation = gql`
  mutation CreateAuthenticationTokenMutation($email: String!, $password: String!) {
    accessToken: createAccessToken(
      input: {type: Authentication, email: $email, password: $password}
    ) {
      token
      userId
    }
  }
`;

export const useCreateAuthenticationTokenMutation = () => {
  const [createAccessToken, {loading}] = useMutation<
    CreateAuthenticationTokenMutation,
    CreateAuthenticationTokenMutationVariables
  >(createAccessTokenMutation);

  const handleCreateAccessToken = async (
    variables: CreateAuthenticationTokenMutationVariables,
  ): Promise<{token: string; userId: string} | null> => {
    const result = await createAccessToken({variables});

    if (result.data) {
      return {
        token: result.data.accessToken.token,
        userId: result.data.accessToken.userId!,
      };
    } else {
      console.error('Missing data in create authentication token mutation result!');
      return null;
    }
  };

  return {createAuthenticationToken: handleCreateAccessToken, loading};
};
